module.exports = __webpack_public_path__ + "static/img/img3.7205534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img3.png
// module id = m22b
// module chunks = 1